import { isEmpty, uniqBy } from 'lodash';
import React, { Component } from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'react-redux-form';
import { createPostcodePlan, getPostcodePlan, getPostcodePlanMeta, updatePostcodePlan } from '../../../../../actions/postcode-plan';
import BackLink from '../../../../../components/common/back-link/index';
import ArrowButton from '../../../../../components/common/button-arrow';
import FileUpload from '../../../../../components/common/form/elements/file-upload';
import RequiredDatePicker from '../../../../../components/common/form/elements/required-datepicker';
import RequiredInput from '../../../../../components/common/form/elements/required-input';
import RequiredMultiSelect from '../../../../../components/common/form/elements/required-multi-select';
import PageTitle from '../../../../../components/common/page-title';
import EligibilityDropdowns from '../../eligibility-dropdowns';

import './styles.css';

class AddPostcodePlans extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    this.id = +this.props.match.params.id;
    this.isClone = this.props.match.url.includes('clone');
    this.edit = !Number.isNaN(this.id) && !this.isClone;

    dispatch(getPostcodePlanMeta());

    if (this.edit || this.isClone) {
      dispatch(getPostcodePlan(this.id));
    } else {
      dispatch(actions.reset('deep.postcode_plan'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.postcode_plan'));
  }

  onSubmit = (data) => {
    const { dispatch } = this.props;
    const isError = this.validateForm();

    if (isError) {
      return;
    }

    if (!this.edit) {
      dispatch(actions.submitFields('deep.postcode_plan', createPostcodePlan(data, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.postcode_plan', updatePostcodePlan(this.id, data, dispatch)));
    }
  };

  validateForm = () => {
    const {
      dispatch,
      formData: {
        start_date: startDate,
        end_date: endDate,
        display_from_date: displayFromDate,
        display_to_date: displayToDate,
      }
    } = this.props;
    let isError = false;

    if (endDate !== '' && endDate < startDate) {
      dispatch(actions.setErrors('deep.postcode_plan.end_date', 'End date must be after the start date'));
      isError = true;
    }

    if (displayToDate !== '' && displayToDate < displayFromDate) {
      dispatch(actions.setErrors('deep.postcode_plan.display_to_date', 'Display to date must be after the display from date'));
      isError = true;
    }

    return isError;
  }
  pageTitle = () => {
    if (this.edit) {
      return 'EDIT';
    }

    if (this.isClone) {
      return 'CLONE';
    }

    return 'ADD';
  }

  render() {
    const {
      formValid,
      formData: {
        abm_codes: savedAbmCodes,
        products: savedProducts,
        start_date: startDate,
        end_date: endDate,
        display_from_date: displayFromDate,
        display_to_date: displayToDate,
        category_points: categoryPoints,
        description,
      },
      postcodePlans: {
        fetched,
        meta: {
          products,
          wholesalers
        },
      },
      abmCodes,
      wseBands,
      groups,
      postcodes,
      subZones,
      zones,
    } = this.props;

    const categories = uniqBy((savedProducts || []).map(savedProduct => savedProduct.category), 'id');
    const brands = uniqBy((savedProducts || []).map(savedProduct => savedProduct.brand), 'id');
    let needBrands = false;

    return (
      <div className='container-fluid postcode-plan-form'>
        <Row>
          <Col md={12}>
            <BackLink href='/admin/objectives/postcode-plans'/>
            <PageTitle>{`${this.pageTitle()} POSTCODE PLAN ${(!Number.isNaN(this.id) ? `ID: ${this.id}` : '')}`}</PageTitle>
          </Col>
        </Row>
        {!fetched && 'Loading...' }
        {fetched && (
          <Col md={12}>
            <Row>
              <Form model='deep.postcode_plan' onSubmit={this.onSubmit}>
                <Errors className='errors' model='deep.postcode_plan'/>
                <Row>
                  <Col md={12}>
                    <RequiredInput
                      label='Name'
                      tooltip='This name will display to the user in their store performance and points statement pages'
                      model='.name'
                      placeholder='Name'
                      controlId='postcodePlanName'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <ControlLabel>Description</ControlLabel>
                      <Control.textarea
                        className="form-control"
                        model=".description"
                        rows="5"
                        placeholder="Description"
                        value={description || ''}
                      />
                    </div>
                  </Col>
                </Row>
                <EligibilityDropdowns
                  abm_codes={abmCodes}
                  wse_bands={wseBands}
                  groups={groups}
                  postcodes={postcodes}
                  sub_zones={subZones}
                  zones={zones}
                  model='postcode_plan'
                />
                {(savedAbmCodes || []).map((abmCode) => {
                  const model = `.thresholds.abm-code-${abmCode.value.split('_').join('-')}.threshold`;
                  const label = `${abmCode.value} threshold`;

                  return (
                    <Row key={`abm-code-${abmCode.value.split('_').join('-')}`}>
                      <Col md={12}>
                        {!this.isEdit ? (
                          <div className="form-group">
                            <ControlLabel>{label}</ControlLabel>
                            <Control.text
                              model={model}
                              placeholder='Threshold'
                              type="number"
                              className="form-control"
                            />
                          </div>
                        ) : (
                          <RequiredInput
                            label={label}
                            model={model}
                            placeholder='Threshold'
                            controlId={'threshold'}
                            inputType='number'
                            positive
                          />
                        )}
                      </Col>
                    </Row>
                  );
                })}
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Start Date"
                      controlId="start_date"
                      model="deep.postcode_plan.start_date"
                      value={startDate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="End Date"
                      controlId="end_date"
                      model="deep.postcode_plan.end_date"
                      value={endDate}
                      required={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <RequiredMultiSelect
                      model='deep.postcode_plan.products'
                      data={products || []}
                      label="Products"
                      value={savedProducts}
                      controlId="products"
                      placeholder='Select...'
                    />
                  </Col>
                </Row>
                {(savedProducts || []).length > 0 && (wholesalers || []).map(wholesaler => (
                  <Row key={`wholesaler-${wholesaler.id}`}>
                    <Col md={12}>
                      <h5>{wholesaler.name}</h5>
                    </Col>
                    {categories.map((category) => {
                      const model = `category_points.category-${category.id}.wholesaler-${wholesaler.id}`;

                      if (isEmpty(categoryPoints) || categoryPoints[`category-${category.id}`] === undefined) {
                        needBrands = true;
                        return null;
                      }

                      const { points, discount } = categoryPoints[`category-${category.id}`][`wholesaler-${wholesaler.id}`];

                      if (points === null || discount === null) {
                        needBrands = true;
                        return null;
                      }

                      return (
                        <Col md={12} key={`category-${category.id}`}>
                          <Col md={4}>{category.name}</Col>
                          <Col md={4}>
                            <div className="form-group">
                              <ControlLabel>Discount</ControlLabel>
                              <Control.text
                                className="form-control"
                                model={`.${model}.discount`}
                                placeholder='Discount'
                                controlId='discount'
                                type='number'
                                step='any'
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="form-group">
                              <ControlLabel>Points</ControlLabel>
                              <Control.text
                                className="form-control"
                                model={`.${model}.points`}
                                placeholder='Points'
                                controlId='points'
                                type='number'
                              />
                            </div>
                          </Col>
                        </Col>
                        );
                    })}
                    {brands.map((brand) => {
                      const model = `brand_points.brand-${brand.id}.wholesaler-${wholesaler.id}`;

                      if (needBrands) {
                        return (
                          <Col md={12} key={`brand-${brand.id}`}>
                            <Col md={4}>{brand.name}</Col>
                            <Col md={4}>
                              <RequiredInput
                                label="Discount"
                                model={`.${model}.discount`}
                                placeholder='Discount'
                                controlId='discount'
                                type='number'
                                step='any'
                                positive
                              />
                            </Col>
                            <Col md={4}>
                              <RequiredInput
                                label='Points'
                                model={`.${model}.points`}
                                placeholder='Points'
                                controlId='points'
                                type='number'
                                positive
                              />
                            </Col>
                          </Col>
                        );
                      }
                      return (
                        <Col md={12} key={`category-${brand.id}`}>
                          <Col md={4}>{brand.name}</Col>
                          <Col md={4}>
                            <div className="form-group">
                              <ControlLabel>Discount</ControlLabel>
                              <Control.text
                                className="form-control"
                                model={`.${model}.discount`}
                                placeholder='Discount'
                                controlId='discount'
                                type='number'
                                step='any'
                              />
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="form-group">
                              <ControlLabel>Points</ControlLabel>
                              <Control.text
                                className="form-control"
                                model={`.${model}.points`}
                                placeholder='Points'
                                controlId='points'
                                type='number'
                              />
                            </div>
                          </Col>
                        </Col>
                      );
                  })}
                  </Row>
                ))}
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <ControlLabel>Opt in Bonus (points)</ControlLabel>
                      <Control.text
                        className="form-control"
                        model=".opt_in_bonus_points"
                        placeholder="Opt in Bonus (points)"
                        type='number'
                      />
                    </div>
                  </Col>
                </Row>
                {!this.edit && (
                  <Row>
                    <Col md={12}>
                      <FileUpload
                        label="Opt in Bonus outlets"
                        model='.opt_in_bonus_outlets'
                        type={['text/csv', 'application/vnd.ms-excel']}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    <RequiredInput
                      label='Administration validation threshold (points)'
                      model='.administration_validation_threshold'
                      placeholder='Administration validation threshold (points)'
                      controlId='administrationValidationThreshold'
                      inputType='number'
                      positive
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Display From Date"
                      controlId="display_from_date"
                      model="deep.postcode_plan.display_from_date"
                      value={displayFromDate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Display To Date"
                      controlId="display_to_date"
                      model="deep.postcode_plan.display_to_date"
                      value={displayToDate}
                      required={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <ArrowButton className='float-right' color='red' disabled={!formValid}>
                      save
                    </ArrowButton>
                  </Col>
                </Row>
              </Form>
            </Row>
          </Col>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.postcode_plan.$form.valid,
  formData: state.deep.postcode_plan,
  postcodePlans: state.postcode_plans,
  groups: state.deep.postcode_plan.groups || [],
  abmCodes: state.deep.postcode_plan.abm_codes || [],
  wseBands: state.deep.postcode_plan.wse_bands || [],
  postcodes: state.deep.postcode_plan.postcodes || [],
  subZones: state.deep.postcode_plan.sub_zones || [],
  zones: state.deep.postcode_plan.zones || [],
  thresholds: state.deep.postcode_plan.thresholds || []
});

export default connect(mapStateToProps)(AddPostcodePlans);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/postcode_plans/add-postcode-plans/index.jsx